import { getPersonaIdFromAgentId } from '@/entities/agent';
import { useCurrentAgentId } from '@/features/chats';

/**
 * The persona the chat is talking to is the current agent. It is restored from the
 * history's `activeAgent` on reload and moved by every live handoff, so it stays right
 * after a refresh and through a mid-chat switch. The store's messages are not a source:
 * they are only written when a live reply finishes, never from loaded history.
 */
export function useSelectedPersonaIdFromChatAdapter(): string | null {
  return getPersonaIdFromAgentId(useCurrentAgentId());
}
